/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Portal_HintInputs */

const cs_client_portal_hint = /** @type {(inputs: Client_Portal_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozvěte osobu do klientského portálu, aby mohla komunikovat s kanceláří.`)
};

const en_client_portal_hint = /** @type {(inputs: Client_Portal_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite this person to the client portal so they can message your office.`)
};

/**
* | output |
* | --- |
* | "Invite this person to the client portal so they can message your office." |
*
* @param {Client_Portal_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const client_portal_hint = /** @type {((inputs?: Client_Portal_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Portal_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_portal_hint(inputs)
	return cs_client_portal_hint(inputs)
});